<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  receipertEdit,
  receipertDetail,
} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/account/receipt/edit',
      formComponents: ['baseForm'],

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        mobilePhone: '',
        linkman: '',
        receiverName: '',
        remark: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        relId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: receipertDetail,
    editApi: receipertEdit,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
